module.exports = __webpack_public_path__ + "static/media/21ECLAC49.9d626443.jpg";